import React, { Component } from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import Done from "material-ui/svg-icons/action/done";
import InputField from "../framework/InputField/InputField";
// import SelectField from 'material-ui/SelectField';
// import MenuItem from 'material-ui/MenuItem';
import Dropzone from "react-dropzone";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import Tooltip from "rc-tooltip";
import TipIcon from "material-ui/svg-icons/action/info-outline";
import Select from "react-select";
import { findIndex } from "lodash";
import CustomSelect from "../framework/CustomSelect/CustomSelect";
import groupBy from "lodash/groupBy";
import MaskedInput from "react-text-mask";
// button color
import { buttonBlueColor } from "../../utils/utility";

import loading from "../../../public/Spinner.gif";
import "./profile.css";

// import web workers;
import profileWorker from "./worker";

// default img
import imageNotAvailable from "./image_not_available.png";

// icon
// import ArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import Error from "material-ui/svg-icons/alert/error";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.flag = true;
    this.flagBase = true;
    this.flagPhoto = true;
    this.myProfile_worker = new Worker(profileWorker);
    this.throttle_getRole = true;
    this.state = {
      ifHiddenTopEdit: true, // if show top form edit
      ifHiddenBottomEdit: true,
      ifHiddenLogoEdit: true,
      ifHiddenPhototEdit: true,
      ifHiddenChangePw: true,
      requiredFirstNameText: "", // requied field firset name tip text
      requiredLastNameText: "", // required field last name tip text
      requiredEmailText: "", // required field email tip text
      requiredIndustryIdText: "",
      requiredTimezoneText: "",
      ifLogoUploadButtonEnable: false, // if upload button enable for logo
      ifPhotoUploadButtonEnable: false, // if uploda button enable for photo
      ifLogoSaveBtnEnable: false, // if logo save button can be request api
      ifPhotoSaveBtnEnable: false, // if photo save button can be request api
      logoFileName: "No file chosen",
      photoFileName: "No file chosen",
      logoUploadSuccess: false,
      photoUploadSucess: false,
      roleValue: "",
      stateValue: "",
      timezoneValue: "",
      departmentValue: "",
      industryValue: "",
      clientId: "", // client id for upload
      companyLogoErrorText: "",
      profilePhotoErrorText: "",
      companyLogoUuid: "", // logo uuid
      userAvatarUuid: "",
      roleInfo: "", // store role object information
      industryGroupObj: [], // for industry type selection
      showCityValueTypeTip: false,
      requestParams: {
        title: "",
        companyName: "",
        firstName: "",
        lastName: "",
        email: "",
        username: "",
        address1: "",
        address2: "",
        city: "",
        zipCode: "",
        officePhone: "",
        mobilePhone: "",
        timezone: "",
      },
      passwordRequestParams: {
        password: Math.random().toString(36).substr(2),
        confirmPassword: "",
      },
      imgDataBase64: "", // for company logo
      imgPhotoDataBase64: "", // for photo,
      // password_error_tip_show: false,
      newLogoBase64: "",
      newPhotoBase64: "",
      showNewPwError: false,
      showConfirmPwError: false,
      showBaseInfoError: false,
    };
  }
  componentDidMount() {
    this.props.getDepartment();
    this.props.getStates();
    this.props.getTimezone();
    this.props.getIndustryOptions();
    localStorage.setItem("newLogoBase64", "");
    localStorage.setItem("newPhotoBase64", "");
  }
  componentWillReceiveProps(nextProps) {
    // default img
    if (
      /^SYSTEM ADMINISTRATOR/.test(nextProps.rolesName) &&
      this.throttle_getRole
    ) {
      this.props.getRoles();
      this.throttle_getRole = false;
    }
    if (
      nextProps.company_logo !== "" &&
      nextProps.loginUserDetail.client.logo !== "logo.png"
    ) {
      // change blob to base64 for img element. and implement one time.

      if (this.flagBase) {
        this.myProfile_worker.postMessage(nextProps.company_logo);
        this.myProfile_worker.onmessage = (e) => {
          this.setState({
            imgDataBase64: e.data,
          });
        };
      }
    } else {
      this.setState({
        imgDataBase64: imageNotAvailable,
      });
    }

    // change blob to base64 for photo
    if (
      typeof nextProps.avatar !== "undefined" &&
      nextProps.loginUserDetail.avatar !== "avatar.png"
    ) {
      if (this.flagPhoto) {
        let reader = new FileReader();
        reader.readAsDataURL(nextProps.avatar);
        reader.onload = () => {
          this.setState({
            imgPhotoDataBase64: reader.result,
          });
        };
      }
    } else {
      this.setState({
        imgPhotoDataBase64: imageNotAvailable,
      });
    }

    if (nextProps.industryOptions.length > 0) {
      this.setState({
        industryValue: "",
      });
      let industryGroup = groupBy(nextProps.industryOptions, "group");
      let obj = [];
      // obj.push({label: 'All Industries', options: [
      //   {
      //     label: 'All Industries',
      //     value: ''
      //   }
      // ]})
      for (let x in industryGroup) {
        obj.push({
          label: x,
          options: industryGroup[x],
        });
      }
      this.setState({
        industryGroupObj: obj,
      });
    }

    if (nextProps.loginUserDetail) {
      const {
        firstName,
        lastName,
        email,
        role,
        username,
        department,
        state,
        id,
        address1,
        address2,
        city,
        zipCode,
        officePhone,
        mobilePhone,
        timezone,
        title,
        companyName,
        client,
      } = nextProps.loginUserDetail;
      this.setState({
        clientId: id,
      });
      // implement one time.
      if (this.flag) {
        this.props.getCompanyLogo(nextProps.loginUserDetail.client.id); // get logo img
        // this.props.getUserAvatar(nextProps.loginUserDetail.avatar); // get photo img
        this.flag = false;
      }

      this.setState({
        roleValue: role.id,
        departmentValue: department.id,
        industryValue: client.industry.id,
        stateValue: state,
        timezoneValue: timezone,
        roleInfo: role,
        requestParams: {
          ...this.state.requestParams,
          firstName,
          lastName,
          email,
          title,
          username: username || "",
          // state: state || nextProps.allstates[0].value,
          // departmentId: department.id || nextProps.department[0].value,
          address1: address1 || "",
          address2: address2 || "",
          city: city || "",
          zipCode: zipCode || "",
          officePhone: officePhone || "",
          mobilePhone: mobilePhone || "",
          timezone: timezone || nextProps.timezone[0].value,
          companyName: companyName || "",
          industryId: client.industry.id || "",
        },
      });
    }
  }
  getTimezoneText(tz) {
    const { timezone } = this.props;
    const idx = findIndex(timezone, function (o) {
      return o.value === tz;
    });
    const t = timezone[idx];
    return t && t.label ? t.label : "";
  }
  getDepartmentText(id) {
    const { department } = this.props;
    const idx = findIndex(department, function (o) {
      return o.value === id;
    });
    const d = department[idx];
    return d && d.label ? d.label : "";
  }

  getStateText(abbr) {
    const { allstates } = this.props;
    const idx = findIndex(allstates, function (o) {
      return o.value === abbr;
    });
    const s = allstates[idx];

    return s && s.label ? s.label : "";
  }
  handleTopCreate() {
    this.setState({
      ifHiddenTopEdit: false,
    });
  }
  handleCancelEdit() {
    const {
      title,
      firstName,
      lastName,
      email,
      role,
      username,
      department,
      state,
      address1,
      address2,
      city,
      zipCode,
      officePhone,
      mobilePhone,
      timezone,
      companyName,
      client,
    } = this.props.loginUserDetail;
    this.setState({
      ifHiddenTopEdit: true,
      roleValue: role.id,
      departmentValue: department.id,
      stateValue: state,
      timezoneValue: timezone,
      industryValue: client.industry.id,
      roleInfo: role,
      showBaseInfoError: false,
      requiredFirstNameText: "", // requied field firset name tip text
      requiredLastNameText: "", // required field last name tip text
      requiredEmailText: "", // required field email tip text
      requiredIndustryIdText: "",
      requiredTimezoneText: "",
      requestParams: {
        ...this.state.requestParams,
        firstName,
        lastName,
        email,
        username: username || "",
        state: state || this.props.allstates[0].value,
        departmentId: department.id || this.props.department[0].value,
        address1: address1 || "",
        address2: address2 || "",
        city: city || "",
        zipCode: zipCode || "",
        officePhone: officePhone || "",
        mobilePhone: mobilePhone || "",
        companyName: companyName || "",
        timezone: timezone || this.props.timezone[0].value,
        title: title || "",
        industryId: client.industry.id || "",
      },
    });
  }
  handleItemsChange(e, index, value) {
    this.setState({
      roleValue: value,
    });
  }
  handleDepartmentChange(value) {
    this.setState({
      departmentValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        departmentId: value.value,
      },
    });
  }
  handleStateChange(value) {
    this.setState({
      stateValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        state: value.value,
      },
    });
  }
  handleTimeZoneChange(value) {
    this.setState({
      timezoneValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        timezone: value.value,
      },
    });
  }
  handleTitle(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        title: value,
      },
    });
  }
  handleFirstName(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        firstName: value,
      },
    });
  }
  handleLastName(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        lastName: value,
      },
    });
  }
  handleEmail(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        email: value,
      },
    });
  }
  handleUsername(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        username: value,
      },
    });
  }
  handleCompanyAdd1(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        address1: value,
      },
    });
  }
  handleCompanyAdd2(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        address2: value,
      },
    });
  }
  handleCity(e, value) {
    if (/^\d/g.test(value)) {
      this.setState({
        requestParams: {
          ...this.state.requestParams,
          city: "",
        },
        showCityValueTypeTip: true,
      });
    } else {
      this.setState({
        requestParams: {
          ...this.state.requestParams,
          city: value,
        },
        showCityValueTypeTip: false,
      });
    }
  }
  handleZipCode(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        zipCode: value,
      },
    });
  }
  handleOfficePhoneNumber(e) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        officePhone: e.target.value,
      },
    });
  }
  handleCompanyName(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        companyName: value,
      },
    });
  }
  handleMobilePhoneNumber(e) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        mobilePhone: e.target.value,
      },
    });
  }
  handleDrop(files, accept, reject) {
    this.setState({
      logoFileName: files[0],
      ifLogoUploadButtonEnable: true,
      companyLogoErrorText: "",
    });
  }
  handleDropProfile(files, accept, reject) {
    this.setState({
      photoFileName: files[0],
      ifPhotoUploadButtonEnable: true,
      profilePhotoErrorText: "",
    });
  }
  onDropRejected() {
    this.setState({
      companyLogoErrorText:
        "Only jpg, png, and gif file with maximum size of 1MB is allowed",
    });
  }
  onDropProfileRejected() {
    this.setState({
      profilePhotoErrorText:
        "Only jpg, png, and gif file with maximum size of 1MB is allowed",
    });
  }
  handleUpdateProfile() {
    if (this.state.requestParams.firstName.trim().length === 0) {
      this.setState({
        requiredFirstNameText: "Please enter your first name",
      });
    } else {
      this.setState({
        requiredFirstNameText: "",
      });
    }
    if (this.state.requestParams.lastName.trim().length === 0) {
      this.setState({
        requiredLastNameText: "Please enter your last name",
      });
    } else {
      this.setState({
        requiredLastNameText: "",
      });
    }
    if (this.state.requestParams.email.trim().length === 0) {
      this.setState({
        requiredEmailText: "Please enter your email",
      });
    } else {
      this.setState({
        requiredEmailText: "",
      });
    }
    if (typeof this.state.requestParams.industryId === "string") {
      this.setState({
        requiredIndustryIdText: "Please select your industry type",
      });
    } else {
      this.setState({
        requiredIndustryIdText: "",
      });
    }
    if (typeof this.state.requestParams.timezone === "string") {
      this.setState({
        requiredTimezoneText: "Please select your timezone",
      });
    } else {
      this.setState({
        requiredTimezoneText: "",
      });
    }
    if (
      this.state.requestParams.firstName.trim().length > 0 &&
      this.state.requestParams.lastName.trim().length > 0 &&
      this.state.requestParams.email.trim().length > 0 &&
      typeof this.state.requestParams.industryId === "number"
    ) {
      this.props.updateProfile(this.state.requestParams);
      this.setState({
        showBaseInfoError: true,
      });
    }
  }
  handleCloseDialog() {
    // reload redux
    this.props.setStatus(false);
    this.props.getCurrentUserProfile(); // request my profile again
    this.flag = true;
    this.flagBase = true;
    this.flagPhoto = true;
    this.setState({
      ifHiddenTopEdit: true, // if show top form edit
      ifHiddenBottomEdit: true,
      ifHiddenLogoEdit: true,
      ifHiddenPhototEdit: true,
      ifHiddenChangePw: true,
      ifLogoSaveBtnEnable: false,
      ifPhotoSaveBtnEnable: false,
      logoUploadSuccess: false,
      photoUploadSucess: false,
      requiredFirstNameText: "",
      requiredLastNameText: "",
      requiredEmailText: "",
      requiredIndustryIdText: "",
      requiredTimezoneText: "",
      ifLogoUploadButtonEnable: false,
      ifPhotoUploadButtonEnable: false,
      logoFileName: "No file chosen",
      photoFileName: "No file chosen",
      roleValue: "",
      stateValue: "",
      timezoneValue: "",
      industryValue: "",
      departmentValue: "",
      clientId: "", // client id for upload
      companyLogoErrorText: "",
      profilePhotoErrorText: "",
      companyLogoUuid: "", // logo uuid
      userAvatarUuid: "", // avatar uuid
      industryGroupObj: [],
      showCityValueTypeTip: false,
      requestParams: {
        title: "",
        firstName: "",
        lastName: "",
        email: "",
        username: "",
        address1: "",
        address2: "",
        companyName: "",
        city: "",
        zipCode: "",
        officePhone: "",
        mobilePhone: "",
        timezone: "",
      },
      passwordRequestParams: {
        password: Math.random().toString(36).substr(2),
        confirmPassword: "",
      },
      imgDataBase64: "", // for company logo
      imgPhotoDataBase64: "", // for photo
      newLogoBase64: "",
      newPhotoBase64: "",
      showBaseInfoError: false,
    });
  }
  handleLogoEdit() {
    this.setState({
      ifHiddenLogoEdit: false,
    });
  }
  handlePhotoEdit() {
    this.setState({
      ifHiddenPhototEdit: false,
    });
  }
  handlePhotoLogo() {
    if (this.state.ifPhotoUploadButtonEnable) {
      let formData = new FormData();
      formData.append("avatar", this.state.photoFileName);
      // call api
      fetch(`/api/users/my-profile/photo/upload`, {
        method: "POST",
        body: formData,
        headers: new Headers({
          Authorization: this.props.token,
        }),
      })
        .then(
          (res) => {
            if (res.status === 200) {
              return res.json();
            } else {
              res.json().then((json) => {
                this.setState({
                  profilePhotoErrorText: json.message,
                });
              });
            }
          },
          () => {},
        )
        .then((json) => {
          if (typeof json !== "undefined") {
            localStorage.setItem(
              "newPhotoBase64",
              this.state.photoFileName.preview,
            );
            this.setState({
              profilePhotoErrorText: "",
              ifPhotoSaveBtnEnable: true,
              photoUploadSucess: true,
              userAvatarUuid: json.uuid,
              newPhotoBase64: this.state.photoFileName.preview,
            });
          }
        })

        .catch((err) => {
          alert(err);
        });
      // this.setState({
      //   imgProfileDataBase64: this.state.photoFileName.preview
      // });
    }
  }
  handleUploadLogo() {
    if (this.state.ifLogoUploadButtonEnable) {
      let formData = new FormData();
      formData.append("logo", this.state.logoFileName);
      // call api
      fetch(
        `/api/clients/${this.props.loginUserDetail.client.id}/logo/upload`,
        {
          method: "POST",
          body: formData,
          headers: new Headers({
            Authorization: this.props.token,
          }),
        },
      )
        .then(
          (res) => {
            if (res.status === 200) {
              return res.json();
            } else {
              res.json().then((json) => {
                this.setState({
                  companyLogoErrorText: json.message,
                });
              });
            }
          },
          () => {},
        )
        .then((json) => {
          if (typeof json !== "undefined") {
            localStorage.setItem(
              "newLogoBase64",
              this.state.logoFileName.preview,
            );
            this.setState({
              companyLogoErrorText: "",
              ifLogoSaveBtnEnable: true,
              logoUploadSuccess: true,
              companyLogoUuid: json.uuid,
              newLogoBase64: this.state.logoFileName.preview,
            });
          }
        })
        .catch((err) => {
          alert(err);
        });
    }
  }
  handleCancelLogoEdit() {
    this.setState({
      ifHiddenLogoEdit: true,
      newLogoBase64: "",
      logoFileName: "No file chosen",
    });
    localStorage.setItem("newLogoBase64", "");
  }
  handleIndustryChange(value) {
    this.setState({
      industryValue: value.value,
      requestParams: {
        ...this.state.requestParams,
        industryId: value.value,
      },
    });
  }
  handleUpdatelogo() {
    if (this.state.ifLogoSaveBtnEnable) {
      this.props.updateLogo(
        this.props.loginUserDetail.client.id,
        this.state.companyLogoUuid,
      );
    }
  }
  handleUpdatePhoto() {
    if (this.state.ifPhotoSaveBtnEnable) {
      this.props.updatePhoto(this.state.userAvatarUuid);
    }
  }
  handleCancelPhotoEdit() {
    this.setState({
      ifHiddenPhototEdit: true,
      newPhotoBase64: "",
      photoFileName: "No file chosen",
    });
    localStorage.setItem("newPhotoBase64", "");
  }
  handlChangePwEdit() {
    this.setState({
      ifHiddenChangePw: false,
      passwordRequestParams: {
        ...this.state.passwordRequestParams,
        password: "",
      },
    });
  }
  handleNewPassword(e, value) {
    this.setState({
      passwordRequestParams: {
        ...this.state.passwordRequestParams,
        password: value.trim(),
      },
      showNewPwError: false,
    });
  }
  handleConfirmPassword(e, value) {
    this.setState({
      passwordRequestParams: {
        ...this.state.passwordRequestParams,
        confirmPassword: value.trim(),
      },
      showConfirmPwError: false,
    });
  }
  handleChangePwSave() {
    if (
      !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(
        this.state.passwordRequestParams.password,
      ) &&
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(
        this.state.passwordRequestParams.confirmPassword,
      )
    ) {
      this.setState({
        showNewPwError: true,
      });
    } else if (
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(
        this.state.passwordRequestParams.password,
      ) &&
      !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(
        this.state.passwordRequestParams.confirmPassword,
      )
    ) {
      this.setState({
        showConfirmPwError: true,
      });
    } else if (
      !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(
        this.state.passwordRequestParams.password,
      ) &&
      !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,}$/g.test(
        this.state.passwordRequestParams.confirmPassword,
      )
    ) {
      this.setState({
        showConfirmPwError: true,
        showNewPwError: true,
      });
    } else {
      this.setState({
        showConfirmPwError: true,
      });
    }

    this.props.changePassword(this.state.passwordRequestParams);
  }
  handleCancelPwEdit() {
    this.setState({
      ifHiddenChangePw: true,
      showNewPwError: false,
      showConfirmPwError: false,
      passwordRequestParams: {
        password: Math.random().toString(36).substr(2),
        confirmPassword: "",
      },
    });
  }
  _pwdInputKeyDown(e) {
    if (e.keyCode === 32) e.preventDefault();
  }

  render() {
    const actions = [
      <FlatButton
        className={"btn-aa-info"}
        label="Close"
        primary={true}
        backgroundColor={buttonBlueColor()}
        labelStyle={{ color: "white" }}
        hoverColor={buttonBlueColor()}
        onClick={() => this.handleCloseDialog()}
      />,
    ];
    const muiTheme = getMuiTheme({
      menuItem: {
        hoverColor: buttonBlueColor(),
      },
    });
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="profile">
          <div className="profile-wrapper">
            <div className="profile-form-top">
              <h1
                style={{
                  borderBottom: this.state.ifHiddenTopEdit ? "" : "none",
                }}
              >
                MY PROFILE
              </h1>
              {/^(administrator|team member|Business Unit Team Member)/gi.test(
                this.props.roleName,
              ) && (
                <div
                  className="profile-fn-wrapper clearfix"
                  style={{
                    lineHeight: "32px",
                    borderBottom: this.state.ifHiddenTopEdit
                      ? "2px solid grey"
                      : "",
                  }}
                >
                  {/*<InputField*/}
                  {/*labelTitle="Client Name"*/}
                  {/*onChange={(e, value) => this.handleTitle(e, value)}*/}
                  {/*ifHasBorder={this.state.ifHiddenTopEdit}*/}
                  {/*initValue={this.state.requestParams.title}*/}
                  {/*borderColor="black"*/}
                  {/*labelStyle={{float:'left', fontSize: '13px', fontWeight: 'bolder', width: '30%', margin: 0}}*/}
                  {/*inputContainerId="firstName"*/}
                  {/*style={{height: '32px', borderBottom: this.state.ifHiddenTopEdit ? '2px solid grey' : '', lineHeight: '32px', marginBottom: 0}}*/}
                  {/*/>*/}
                  <span
                    style={{
                      float: "left",
                      fontSize: "13px",
                      fontWeight: "bolder",
                      width: "30%",
                    }}
                  >
                    {/^(Business Unit Team Member)/gi.test(this.props.roleName)
                      ? "Bussiness Unit Name"
                      : "ClientName"}
                  </span>
                  <strong
                    style={{
                      fontWeight: "normal",
                      fontSize: "13px",
                      paddingLeft: this.state.ifHiddenTopEdit ? "10px" : "",
                    }}
                  >
                    {this.props.loginUserDetail &&
                      this.props.loginUserDetail.client.name}
                  </strong>
                </div>
              )}
              <div
                className="role-intro clearfix"
                style={{ border: !this.state.ifHiddenTopEdit ? "none" : "" }}
              >
                <span>Role</span>
                <small
                  style={{
                    paddingLeft: this.state.ifHiddenTopEdit ? "10px" : "",
                  }}
                >
                  {typeof this.props.loginUserDetail !== "undefined" &&
                    this.props.loginUserDetail.role.name}
                </small>
                <Tooltip
                  placement="right"
                  overlayClassName="profile-role-info"
                  overlayStyle={{ width: "37%" }}
                  overlay={
                    <div className="profile-overlay-container">
                      <p>{this.state.roleInfo.name}</p>
                      <ul>
                        {this.state.roleInfo !== "" &&
                          this.state.roleInfo.capabilities.map(
                            (item, index) => (
                              <li className="clearfix" key={index}>
                                <div
                                  className="icon"
                                  style={{ background: buttonBlueColor() }}
                                >
                                  <Done
                                    style={{
                                      width: "13px",
                                      height: "13px",
                                      color: "white",
                                    }}
                                  />
                                </div>
                                {/*{*/}
                                {/*<section>*/}
                                {/*{index === 0 && item}*/}
                                {/*</section>*/}
                                {/*}*/}
                                {/*{*/}
                                {/*<section>*/}
                                {/*{index === 2 && item}*/}
                                {/*</section>*/}
                                {/*}*/}
                                <section>{item}</section>
                              </li>
                            ),
                          )}
                      </ul>
                    </div>
                  }
                  arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                  <TipIcon
                    style={{
                      color: "black",
                      width: "25px",
                      height: "25px",
                      marginTop: "9px",
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              </div>
              <div className="profile-form">
                <div className="top">
                  <div
                    className="top-shadow"
                    style={{
                      display: this.state.ifHiddenTopEdit ? "block" : "none",
                    }}
                  ></div>
                  <div className="profile-fn-wrapper">
                    <InputField
                      labelTitle="Title"
                      onChange={(e, value) => this.handleTitle(e, value)}
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      initValue={this.state.requestParams.title}
                      borderColor="black"
                      labelStyle={{
                        float: "left",
                        fontSize: "13px",
                        fontWeight: "bolder",
                        width: "30%",
                        margin: 0,
                      }}
                      inputContainerId="firstName"
                      style={{
                        lineHeight: "32px",
                        borderBottom: this.state.ifHiddenTopEdit
                          ? "2px solid grey"
                          : "",
                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                      }}
                    />
                  </div>
                  <div className="profile-fn-wrapper">
                    <InputField
                      labelTitle="First Name"
                      ifRequireField={true}
                      onChange={(e, value) => this.handleFirstName(e, value)}
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      initValue={this.state.requestParams.firstName}
                      hintText={this.state.requestParams.firstName}
                      borderColor="black"
                      labelStyle={{
                        float: "left",
                        fontSize: "13px",
                        fontWeight: "bolder",
                        width: "30%",
                        margin: 0,
                      }}
                      inputContainerId="firstName"
                      style={{
                        lineHeight: "32px",
                        borderBottom: this.state.ifHiddenTopEdit
                          ? "2px solid grey"
                          : "",
                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                      }}
                    />
                    {this.state.requiredFirstNameText && (
                      <p className="create-account-field-error clearfix">
                        <Error style={{ float: "left" }} color="red" />
                        <span>{this.state.requiredFirstNameText}</span>
                      </p>
                    )}
                  </div>
                  <div className="profile-ln-wrapper">
                    <InputField
                      labelTitle="Last Name"
                      ifRequireField={true}
                      onChange={(e, value) => this.handleLastName(e, value)}
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      labelStyle={{
                        float: "left",
                        fontSize: "13px",
                        fontWeight: "bolder",
                        width: "30%",
                        margin: 0,
                      }}
                      inputContainerId="lastName"
                      initValue={this.state.requestParams.lastName}
                      hintText={this.state.requestParams.lastName}
                      borderColor="black"
                      style={{
                        lineHeight: "32px",
                        borderBottom: this.state.ifHiddenTopEdit
                          ? "2px solid grey"
                          : "",
                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                      }}
                    />
                    {this.state.requiredLastNameText && (
                      <p className="create-account-field-error clearfix">
                        <Error style={{ float: "left" }} color="red" />
                        <span>{this.state.requiredLastNameText}</span>
                      </p>
                    )}
                  </div>
                  <div className="profile-email-wrapper">
                    <InputField
                      labelTitle="E-mail Address"
                      ifRequireField={true}
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      labelStyle={{
                        float: "left",
                        fontSize: "13px",
                        fontWeight: "bolder",
                        width: "30%",
                        margin: 0,
                      }}
                      onChange={(e, value) => this.handleEmail(e, value)}
                      initValue={this.state.requestParams.email}
                      hintText={this.state.requestParams.email}
                      inputContainerId="emailAddress"
                      borderColor="black"
                      style={{
                        lineHeight: "32px",
                        borderBottom: this.state.ifHiddenTopEdit
                          ? "2px solid grey"
                          : "",
                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                      }}
                    />
                    {this.state.requiredEmailText && (
                      <p className="create-account-field-error clearfix">
                        <Error style={{ float: "left" }} color="red" />
                        <span>{this.state.requiredEmailText}</span>
                      </p>
                    )}
                  </div>
                  <div className="profile-username">
                    {/*<div className="top-shadow" style={{display: this.state.ifHiddenTopEdit ? 'block' : 'none'}}></div>*/}
                    <InputField
                      labelTitle="Username"
                      labelStyle={{
                        float: "left",
                        fontSize: "13px",
                        fontWeight: "bolder",
                        width: "30%",
                        margin: 0,
                      }}
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      initValue={this.state.requestParams.username}
                      hintText={this.state.requestParams.username}
                      onChange={(e, value) => this.handleUsername(e, value)}
                      inputContainerId="username"
                      borderColor="black"
                      style={{
                        lineHeight: "32px",
                        borderBottom: this.state.ifHiddenTopEdit
                          ? "2px solid grey"
                          : "",
                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                      }}
                    />
                  </div>
                  {!/^(administrator|team member|Business Unit Team Member)/gi.test(
                    this.props.roleName,
                  ) && (
                    <div
                      className="role clearfix"
                      style={{
                        lineHeight: "32px",
                        height: this.state.ifHiddenTopEdit ? "" : "32px",
                        borderBottom: this.state.ifHiddenTopEdit
                          ? "2px solid grey"
                          : "",
                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                      }}
                    >
                      <p
                        style={{
                          color: "black",
                          fontSize: "13px",
                          float: "left",
                          width: "30%",
                          margin: 0,
                          fontWeight: "bolder",
                        }}
                      >
                        Department
                      </p>
                      {this.state.ifHiddenTopEdit ? (
                        <div
                          className="pull-left pl-10"
                          style={{ width: "68%" }}
                        >
                          {this.getDepartmentText(this.state.departmentValue)}
                        </div>
                      ) : (
                        <Select
                          className="cp-dropdown "
                          value={this.state.departmentValue}
                          clearable={false}
                          options={this.props.department}
                          onChange={(value) =>
                            this.handleDepartmentChange(value)
                          }
                        />
                      )}
                    </div>
                  )}
                  <div
                    className="profile-mobile-phone-number clearfix"
                    style={{
                      borderBottom: this.state.ifHiddenTopEdit
                        ? "2px solid grey"
                        : "",
                      marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px",
                    }}
                  >
                    <span
                      style={{
                        marginTop: this.state.ifHiddenTopEdit ? "" : "10px",
                      }}
                    >
                      Mobile Phone Number
                    </span>
                    <MaskedInput
                      className="mp-mask"
                      guide={false}
                      value={this.state.requestParams.mobilePhone}
                      style={{
                        border: this.state.ifHiddenTopEdit
                          ? ""
                          : "1px solid black",
                        height: this.state.ifHiddenTopEdit ? "" : "32px",
                      }}
                      mask={[
                        "(",
                        /[1-9]/,
                        /\d/,
                        /\d/,
                        ")",
                        " ",
                        /\d/,
                        /\d/,
                        /\d/,
                        "-",
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                      ]}
                      onChange={(e) => this.handleMobilePhoneNumber(e)}
                    />
                  </div>
                  <div
                    className="profile-mobile-phone-number clearfix"
                    style={{
                      borderBottom: this.state.ifHiddenTopEdit
                        ? "2px solid grey"
                        : "",
                      marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px",
                    }}
                  >
                    <span
                      style={{
                        marginTop: this.state.ifHiddenTopEdit ? "" : "10px",
                      }}
                    >
                      Office Phone Number
                    </span>
                    <MaskedInput
                      className="mp-mask"
                      guide={false}
                      value={this.state.requestParams.officePhone}
                      style={{
                        border: this.state.ifHiddenTopEdit
                          ? ""
                          : "1px solid black",
                        height: this.state.ifHiddenTopEdit ? "" : "32px",
                      }}
                      mask={[
                        "(",
                        /[1-9]/,
                        /\d/,
                        /\d/,
                        ")",
                        " ",
                        /\d/,
                        /\d/,
                        /\d/,
                        "-",
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                      ]}
                      onChange={(e) => this.handleOfficePhoneNumber(e)}
                    />
                  </div>
                  {!/^(administrator|team member|Business Unit Team Member)/gi.test(
                    this.props.roleName,
                  ) && (
                    <InputField
                      labelTitle="Company Name"
                      labelStyle={{
                        float: "left",
                        fontSize: "13px",
                        fontWeight: "bolder",
                        width: "30%",
                        margin: 0,
                      }}
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      onChange={(e, value) => this.handleCompanyName(e, value)}
                      initValue={this.state.requestParams.companyName}
                      hintText={this.state.requestParams.companyName}
                      inputContainerId="officeNumber"
                      borderColor="black"
                      style={{
                        lineHeight: "32px",
                        borderBottom: this.state.ifHiddenTopEdit
                          ? "2px solid grey"
                          : "",
                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                      }}
                    />
                  )}
                  <InputField
                    labelTitle={
                      /^(administrator|team member|Business Unit Team Member)/gi.test(
                        this.props.roleName,
                      )
                        ? /^(Business Unit Team Member)/gi.test(
                            this.props.roleName,
                          )
                          ? "Bussiness Unit Address1"
                          : "Client Address 1"
                        : "Company Address 1"
                    }
                    ifHasBorder={this.state.ifHiddenTopEdit}
                    labelStyle={{
                      float: "left",
                      fontSize: "13px",
                      fontWeight: "bolder",
                      width: "30%",
                      margin: 0,
                    }}
                    onChange={(e, value) => this.handleCompanyAdd1(e, value)}
                    initValue={this.state.requestParams.address1}
                    hintText={this.state.requestParams.address1}
                    inputContainerId="companyAddress1"
                    borderColor="black"
                    style={{
                      lineHeight: "32px",
                      borderBottom: this.state.ifHiddenTopEdit
                        ? "2px solid grey"
                        : "",
                      marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                    }}
                  />
                  <InputField
                    labelTitle={
                      /^(administrator|team member|Business Unit Team Member)/gi.test(
                        this.props.roleName,
                      )
                        ? /^(Business Unit Team Member)/gi.test(
                            this.props.roleName,
                          )
                          ? "Bussiness Unit Address2"
                          : "Client Address 2"
                        : "Company Address 2"
                    }
                    ifHasBorder={this.state.ifHiddenTopEdit}
                    labelStyle={{
                      float: "left",
                      fontSize: "13px",
                      fontWeight: "bolder",
                      width: "30%",
                      margin: 0,
                    }}
                    onChange={(e, value) => this.handleCompanyAdd2(e, value)}
                    initValue={this.state.requestParams.address2}
                    hintText={this.state.requestParams.address2}
                    inputContainerId="companyAddress1"
                    borderColor="black"
                    style={{
                      lineHeight: "32px",
                      borderBottom: this.state.ifHiddenTopEdit
                        ? "2px solid grey"
                        : "",
                      marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                    }}
                  />
                  <div className="profile-city-wrapper">
                    <InputField
                      labelTitle="City"
                      ifHasBorder={this.state.ifHiddenTopEdit}
                      labelStyle={{
                        float: "left",
                        fontSize: "13px",
                        fontWeight: "bolder",
                        width: "30%",
                        margin: 0,
                      }}
                      onChange={(e, value) => this.handleCity(e, value)}
                      initValue={this.state.requestParams.city}
                      hintText={this.state.requestParams.city}
                      inputContainerId="city"
                      borderColor="black"
                      style={{
                        lineHeight: "32px",
                        borderBottom: this.state.ifHiddenTopEdit
                          ? "2px solid grey"
                          : "",
                        marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                      }}
                    />
                    {this.state.showCityValueTypeTip && (
                      <p className="profile-city-error">
                        City field should be text only.
                      </p>
                    )}
                  </div>
                  <div
                    className="role clearfix"
                    style={{
                      lineHeight: "32px",
                      height: this.state.ifHiddenTopEdit ? "" : "32px",
                      borderBottom: this.state.ifHiddenTopEdit
                        ? "2px solid grey"
                        : "",
                      marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                    }}
                  >
                    <p
                      style={{
                        color: "black",
                        fontSize: "13px",
                        float: "left",
                        width: "30%",
                        margin: 0,
                        fontWeight: "bolder",
                      }}
                    >
                      State
                    </p>
                    {this.state.ifHiddenTopEdit ? (
                      <div className="pull-left pl-10" style={{ width: "68%" }}>
                        {this.getStateText(this.state.stateValue)}
                      </div>
                    ) : (
                      <Select
                        className="cp-dropdown z-index-199"
                        value={this.state.stateValue}
                        clearable={false}
                        options={this.props.allstates}
                        onChange={(value) => this.handleStateChange(value)}
                      />
                    )}
                    {/*
                    <SelectField
                      value={this.state.stateValue}
                      style={{ float: 'left', width: '68%', fontSize: '13px', height: '32px' }}
                      menuStyle={{ paddingLeft: '10px', border: this.state.ifHiddenTopEdit ? '' : '1px solid #000' }}
                      autoWidth={false}
                      dropDownMenuProps={{
                        iconButton: <ArrowDown />,
                      }}
                      selectedMenuItemStyle={{ color: 'black' }}
                      labelStyle={{ paddingTop: '3px', paddingBottom: '3px', height: '30px', lineHeight: '35px', textTransform: 'uppercase' }}
                      underlineStyle={{ display: 'none' }}
                      iconStyle={{ color: 'gainsboro', top: '-8px', right: '0' }}
                      onChange={(e, index, value) => this.handleStateChange(e, index, value)}
                      listStyle={{ border: '1px solid black' }}
                    >
                      {this.props.allstates.map((item) => (
                        <MenuItem value={item.value} primaryText={item.label} key={item.label} />
                      ))}
                    </SelectField>*/}
                  </div>
                  <InputField
                    labelTitle="Zip Code"
                    ifHasBorder={this.state.ifHiddenTopEdit}
                    labelStyle={{
                      float: "left",
                      fontSize: "13px",
                      fontWeight: "bolder",
                      width: "30%",
                      margin: 0,
                    }}
                    onChange={(e, value) => this.handleZipCode(e, value)}
                    initValue={this.state.requestParams.zipCode}
                    hintText={this.state.requestParams.zipCode}
                    inputContainerId="zipCode"
                    borderColor="black"
                    style={{
                      lineHeight: "32px",
                      borderBottom: this.state.ifHiddenTopEdit
                        ? "2px solid grey"
                        : "",
                      marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                    }}
                  />
                  {/^(administrator|Business Unit Team Member)/gi.test(
                    this.props.roleName,
                  ) && (
                    <div
                      className="role clearfix"
                      style={{
                        lineHeight: "32px",
                        borderBottom: this.state.ifHiddenTopEdit
                          ? "2px solid grey"
                          : "",
                        marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px",
                      }}
                    >
                      <p
                        style={{
                          color: "black",
                          fontSize: "13px",
                          float: "left",
                          width: "30%",
                          margin: 0,
                          fontWeight: "bolder",
                        }}
                      >
                        Industry Type<em style={{ color: "red" }}>*</em>
                      </p>
                      <div
                        className="ac-clients-select-filed"
                        id="industryType"
                        style={{
                          width: "68%",
                          height: "34px",
                          border: this.state.ifHiddenTopEdit
                            ? "none"
                            : "1px solid black",
                        }}
                      >
                        <CustomSelect
                          placeholder="Select Industry Type"
                          options={this.state.industryGroupObj}
                          initValue={this.state.industryValue}
                          onChange={(value) => this.handleIndustryChange(value)}
                        />
                      </div>
                    </div>
                  )}
                  {/^(administrator|team member)/gi.test(this.props.roleName) &&
                    this.state.requiredIndustryIdText && (
                      <p className="create-account-field-error clearfix">
                        <Error style={{ float: "left" }} color="red" />
                        <span>{this.state.requiredIndustryIdText}</span>
                      </p>
                    )}
                  <div
                    className="role clearfix"
                    style={{
                      lineHeight: "32px",
                      borderBottom: this.state.ifHiddenTopEdit
                        ? "2px solid grey"
                        : "",
                    }}
                  >
                    <p
                      style={{
                        color: "black",
                        fontSize: "13px",
                        float: "left",
                        width: "30%",
                        margin: 0,
                        fontWeight: "bolder",
                      }}
                    >
                      Time Zone <em style={{ color: "red" }}>*</em>
                    </p>
                    {this.state.ifHiddenTopEdit ? (
                      <div className="pull-left pl-10" style={{ width: "68%" }}>
                        {this.getTimezoneText(this.state.timezoneValue)}
                      </div>
                    ) : (
                      <Select
                        className="cp-dropdown z-index-198 "
                        value={this.state.timezoneValue}
                        clearable={false}
                        options={this.props.timezone}
                        onChange={(value) => this.handleTimeZoneChange(value)}
                      />
                    )}
                  </div>
                  {/*{*/}
                  {/*this.state.requiredFirstNameText && (*/}
                  {/*<p className="create-account-field-error clearfix">*/}
                  {/*<Error*/}
                  {/*style={{float: 'left'}}*/}
                  {/*color="red"*/}
                  {/*/>*/}
                  {/*<span>{this.state.requiredFirstNameText}</span>*/}
                  {/*</p>*/}
                  {/*)*/}
                  {/*}*/}
                  {/*<div className="role clearfix" style={{lineHeight: '32px', borderBottom: this.state.ifHiddenTopEdit ? '1px solid black' : '', marginBottom: !this.state.ifHiddenTopEdit ? '12px': 0}}>*/}
                  {/*<p style={{color: 'black', fontSize: '13px', float: 'left', width: '30%', margin: 0, fontWeight: 'bolder'}}>Role</p>*/}
                  {/*<SelectField*/}
                  {/*value={this.state.roleValue}*/}
                  {/*style={{float: 'left', width: '68%',fontSize:'13px', height: '32px', border: this.state.ifHiddenTopEdit ? '' : '1px solid black'}}*/}
                  {/*menuStyle={{paddingLeft: '10px'}}*/}
                  {/*autoWidth={false}*/}
                  {/*selectedMenuItemStyle={{color: buttonBlueColor()}}*/}
                  {/*labelStyle={{paddingTop:'3px', paddingBottom: '3px', height: '30px', lineHeight: '35px', textTransform: 'uppercase'}}*/}
                  {/*underlineStyle={{display: 'none'}}*/}
                  {/*iconStyle={{color: 'gainsboro', top: '-8px', right: '0'}}*/}
                  {/*onChange={(e, index, value) => this.handleItemsChange(e, index, value)}*/}
                  {/*>*/}
                  {/*{this.props.roles.map((item) => (*/}
                  {/*<MenuItem value={item.value} primaryText={item.label} key={item.label}/>*/}
                  {/*))}*/}
                  {/*</SelectField>*/}
                  {/*</div>*/}
                </div>
              </div>
              <div className="profile-edit clearfix">
                {this.state.showBaseInfoError && (
                  <p className="profile-baseinfo-error">
                    {this.props.update_error_message}
                  </p>
                )}
                <button
                  className="edit-button"
                  style={{
                    background: buttonBlueColor(),
                    display: this.state.ifHiddenTopEdit ? "block" : "none",
                  }}
                  onClick={() => this.handleTopCreate()}
                >
                  EDIT
                </button>
                <div
                  className="save-group clearfix"
                  style={{
                    display: this.state.ifHiddenTopEdit ? "none" : "block",
                  }}
                >
                  <button
                    className={
                      this.state.ifHiddenTopEdit ? "save" : "add-margin save"
                    }
                    style={{ background: buttonBlueColor() }}
                    onClick={() => this.handleUpdateProfile()}
                  >
                    SAVE
                  </button>
                  <button
                    className="cancel"
                    onClick={() => this.handleCancelEdit()}
                    style={{ marginRight: "10px" }}
                  >
                    CANCEL
                  </button>
                </div>
              </div>
            </div>

            <div className="profile-logo-wrapper">
              {typeof this.props.loginUserDetail !== "undefined" &&
              /^(account manager|operations manager|team member)/gi.test(
                this.props.loginUserDetail.role.name,
              ) ? (
                ""
              ) : (
                <div className="profile-logo profile-company-logo clearfix">
                  <div className="clearfix">
                    <div className="title clearfix">
                      <span id="profile-subtit">LOGO</span>
                    </div>
                    <div className="review">
                      <img
                        src={
                          localStorage.getItem("newLogoBase64") !== ""
                            ? localStorage.getItem("newLogoBase64")
                            : this.state.imgDataBase64 || loading
                        }
                        alt=""
                        style={{
                          display: this.state.ifHiddenLogoEdit
                            ? "inline-block"
                            : "none",
                        }}
                      />
                      <div
                        className="profile-edit-img"
                        style={{
                          display: this.state.ifHiddenLogoEdit
                            ? "none"
                            : "block",
                        }}
                      >
                        <section className="section">
                          Select a logo to upload
                        </section>
                        <Dropzone
                          onDrop={(files, accept, reject) =>
                            this.handleDrop(files, accept, reject)
                          }
                          style={{ width: "100%" }}
                          accept="image/jpeg, image/png, image/jpg, image/gif"
                          maxSize={1048576}
                          onDropRejected={() => this.onDropRejected()}
                          name="logo"
                        >
                          <p
                            style={{
                              textAlign: "center",
                              display: "inline-block",
                              width: "20%",
                              height: "20px",
                              fontSize: "12px",
                              border: "1px solid grey",
                              color: "black",
                              borderRadius: "6px",
                              lineHeight: "20px",
                              marginTop: "10px",
                            }}
                          >
                            Choose File
                          </p>
                          <i style={{ fontStyle: "normal", marginLeft: "6px" }}>
                            {(this.state.logoFileName !== undefined &&
                              this.state.logoFileName.name) ||
                              "No file chosen"}
                          </i>
                          <section className="spec">
                            (Only jpg, png, and gif file with maximum size of
                            1MB is allowed)
                          </section>
                        </Dropzone>
                        <img src={this.state.newLogoBase64} alt="" />
                        <button
                          style={{ background: buttonBlueColor() }}
                          onClick={() => this.handleUploadLogo()}
                        >
                          UPLOAD LOGO
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="error">
                    {this.props.update_logo_msg ||
                      this.state.companyLogoErrorText}
                  </div>
                  <div className="profile-edit clearfix">
                    <button
                      className="edit-button"
                      style={{
                        background: buttonBlueColor(),
                        display: this.state.ifHiddenLogoEdit ? "block" : "none",
                      }}
                      onClick={() => this.handleLogoEdit()}
                    >
                      EDIT
                    </button>
                    <div
                      className="save-group clearfix"
                      style={{
                        display: this.state.ifHiddenLogoEdit ? "none" : "block",
                      }}
                    >
                      <button
                        className={
                          this.state.ifHiddenTopEdit
                            ? "save"
                            : "add-margin save"
                        }
                        disabled={
                          this.state.logoUploadSuccess ? "" : "disabled"
                        }
                        style={{ background: buttonBlueColor() }}
                        onClick={() => this.handleUpdatelogo()}
                      >
                        SAVE
                      </button>
                      <button
                        className="cancel"
                        onClick={() => this.handleCancelLogoEdit()}
                      >
                        CANCEL
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {typeof this.props.loginUserDetail !== "undefined" && (
                <div className="profile-logo profile-photo clearfix">
                  <div className="clearfix">
                    <div className="title clearfix">
                      <span id="profile-subtit">PROFILE PHOTO</span>
                    </div>
                    <div className="review">
                      <img
                        src={
                          localStorage.getItem("newPhotoBase64") !== ""
                            ? localStorage.getItem("newPhotoBase64")
                            : this.state.imgPhotoDataBase64 || loading
                        }
                        alt=""
                        style={{
                          display: this.state.ifHiddenPhototEdit
                            ? "inline-block"
                            : "none",
                        }}
                      />
                      <div
                        className="profile-edit-img"
                        style={{
                          display: this.state.ifHiddenPhototEdit
                            ? "none"
                            : "block",
                        }}
                      >
                        <section className="section">
                          Select a photo to upload
                        </section>
                        <Dropzone
                          onDrop={(files, accept, reject) =>
                            this.handleDropProfile(files, accept, reject)
                          }
                          style={{ width: "100%" }}
                          accept="image/jpeg, image/png, image/jpg, image/gif"
                          maxSize={1048576}
                          onDropRejected={() => this.onDropProfileRejected()}
                          name="avatar"
                        >
                          <p
                            style={{
                              textAlign: "center",
                              display: "inline-block",
                              width: "20%",
                              height: "20px",
                              fontSize: "12px",
                              border: "1px solid grey",
                              color: "black",
                              borderRadius: "6px",
                              lineHeight: "20px",
                              marginTop: "10px",
                            }}
                          >
                            Choose File
                          </p>
                          <i style={{ fontStyle: "normal", marginLeft: "6px" }}>
                            {(this.state.photoFileName !== undefined &&
                              this.state.photoFileName.name) ||
                              "No file chosen"}
                          </i>
                          <section className="spec">
                            (Only jpg, png, and gif file with maximum size of
                            1MB is allowed)
                          </section>
                        </Dropzone>
                        <img src={this.state.newPhotoBase64} alt="" />
                        <button
                          style={{ background: buttonBlueColor() }}
                          onClick={() => this.handlePhotoLogo()}
                        >
                          UPLOAD PHOTO
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="error">
                    {this.props.update_photo_msg ||
                      this.state.profilePhotoErrorText}
                  </div>

                  <div className="profile-edit clearfix">
                    <button
                      className="edit-button"
                      style={{
                        background: buttonBlueColor(),
                        display: this.state.ifHiddenPhototEdit
                          ? "block"
                          : "none",
                      }}
                      onClick={() => this.handlePhotoEdit()}
                    >
                      EDIT
                    </button>
                    <div
                      className="save-group clearfix"
                      style={{
                        display: this.state.ifHiddenPhototEdit
                          ? "none"
                          : "block",
                      }}
                    >
                      <button
                        className={
                          this.state.ifHiddenTopEdit
                            ? "save"
                            : "add-margin save"
                        }
                        disabled={
                          this.state.photoUploadSucess ? "" : "disabled"
                        }
                        style={{ background: buttonBlueColor() }}
                        onClick={() => this.handleUpdatePhoto()}
                      >
                        SAVE
                      </button>
                      <button
                        className="cancel"
                        onClick={() => this.handleCancelPhotoEdit()}
                        style={{ marginRight: "10px" }}
                      >
                        CANCEL
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="profile-change-pw">
                <h1
                  style={{ border: this.state.ifHiddenChangePw ? "" : "none" }}
                >
                  CHANGE YOUR PASSWORD
                </h1>
                <p
                  className="tip"
                  style={{
                    display: this.state.ifHiddenChangePw ? "none" : "block",
                  }}
                >
                  Enter a combination of at least 6 numbers, letters, and
                  special characters
                </p>
                <div className="profile-username">
                  <div
                    className="pw-shadow"
                    style={{
                      display: this.state.ifHiddenTopEdit ? "block" : "none",
                    }}
                  ></div>
                  <div className="profile-fn-wrapper">
                    <InputField
                      labelTitle={
                        this.state.ifHiddenChangePw
                          ? "Password"
                          : "New Password"
                      }
                      ifHasBorder={this.state.ifHiddenChangePw}
                      initValue={this.state.passwordRequestParams.password}
                      onKeyDown={this._pwdInputKeyDown}
                      ifRequireField={true}
                      inputType="password"
                      labelStyle={{
                        float: "left",
                        fontSize: "13px",
                        fontWeight: "bolder",
                        width: "30%",
                        margin: 0,
                      }}
                      inputContainerId="change-password"
                      borderColor="black"
                      onChange={(e, value) => this.handleNewPassword(e, value)}
                      style={{
                        lineHeight: "32px",
                        borderBottom: this.state.ifHiddenChangePw
                          ? "2px solid grey"
                          : "",
                        marginBottom: !this.state.ifHiddenChangePw ? "49px" : 0,
                      }}
                    />
                  </div>
                  <div className="profile-fn-wrapper">
                    <InputField
                      labelTitle={"Confirm Password"}
                      ifHasBorder={this.state.ifHiddenChangePw}
                      inputType="password"
                      onKeyDown={this._pwdInputKeyDown}
                      ifRequireField={true}
                      initValue={
                        this.state.passwordRequestParams.confirmPassword
                      }
                      labelStyle={{
                        float: "left",
                        fontSize: "13px",
                        fontWeight: "bolder",
                        width: "30%",
                        margin: 0,
                      }}
                      inputContainerId="change-password"
                      borderColor="black"
                      onChange={(e, value) =>
                        this.handleConfirmPassword(e, value)
                      }
                      style={{
                        display: this.state.ifHiddenChangePw ? "none" : "block",
                        lineHeight: "32px",
                        borderBottom: this.state.ifHiddenChangePw
                          ? "2px solid grey"
                          : "",
                        marginBottom: !this.state.ifHiddenChangePw ? "40px" : 0,
                      }}
                    />
                  </div>
                </div>
                {this.state.showNewPwError && (
                  <p
                    className="profile-fn-error"
                    style={{ paddingLeft: "30%" }}
                  >
                    {this.props.change_password_error_msg}
                  </p>
                )}
                <div className="profile-edit clearfix">
                  <button
                    className="edit-button"
                    style={{
                      background: buttonBlueColor(),
                      display: this.state.ifHiddenChangePw ? "block" : "none",
                    }}
                    onClick={() => this.handlChangePwEdit()}
                  >
                    EDIT
                  </button>
                  <div
                    className="save-group clearfix"
                    style={{
                      display: this.state.ifHiddenChangePw ? "none" : "block",
                    }}
                  >
                    <button
                      className="save"
                      style={{ background: buttonBlueColor() }}
                      onClick={() => this.handleChangePwSave()}
                    >
                      SAVE
                    </button>
                    <button
                      className="cancel"
                      onClick={() => this.handleCancelPwEdit()}
                    >
                      CANCEL
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*dialog*/}
          <Dialog
            actions={actions}
            modal={false}
            open={this.props.ifUpdateSuccess}
          >
            <p>Update successfully</p>
          </Dialog>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/components/MyProfile/index.jsx